import { useOrganization } from '@clerk/react';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { Feature } from '@/constants/features';
import { useFeatureAccess } from '@/hooks/use-feature-access.hook';

/**
 * Settings › Calling (the native dialer) is open to every member of an org
 * whose plan includes calling, behind `native_dialer_v1`. The flag fails
 * closed: hidden while PostHog loads or can't answer. Admin parts of the page
 * check `useIsAdmin` themselves; the API refuses a member's admin write anyway.
 * `ready` is false until the flag, the plan and the organization answer.
 */
export function useCallingAccess(): { enabled: boolean; ready: boolean } {
  const flag = useFeatureFlagEnabled('native_dialer_v1');
  const { hasFeature, isReady } = useFeatureAccess();
  const { isLoaded, organization } = useOrganization();
  return {
    enabled:
      flag === true && isReady && hasFeature(Feature.DIALER) && !!organization,
    ready: flag !== undefined && isReady && isLoaded,
  };
}
